var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08203 0L0 9.08203V21.918L9.08203 31H21.918L31 21.918V9.08203L21.918 0H9.08203ZM28.0938 20.7167L20.7167 28.0938H10.2838L2.90673 20.7167V10.2838L10.2838 2.90673H20.7167L28.0938 10.2838V20.7167Z",
    fill: "#FF9502"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0469 8.23438H16.9531V15.9844H14.0469V8.23438Z",
    fill: "#FF9502"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0469 19.8594H16.9531V22.7656H14.0469V19.8594Z",
    fill: "#FF9502"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.b205aef329c36768f1f00bc8435b676a.svg";
export { ForwardRef as ReactComponent };